import { useCallback } from 'react';
import { FaTrashAlt } from 'react-icons/fa';
import { useCommonTranslation } from '../../../hooks/i18n/useCommonTranslation';
import { ConfirmDialogProps } from './ConfirmDialog';
import { ConfirmFunction, useConfirmDialog } from './confirmDialogHook';

export type ConfirmDeleteFunction = (
  props: Omit<
    Parameters<ConfirmFunction>[0],
    'status' | 'confirmButtonVariant' | 'icon'
  > & { icon?: ConfirmDialogProps['icon'] },
) => void;

export const useConfirmDeleteDialog = (): {
  confirmDelete: ConfirmDeleteFunction;
} => {
  const { confirm } = useConfirmDialog();
  const { t } = useCommonTranslation();

  const confirmDelete: ConfirmDeleteFunction = useCallback(
    ({ icon, confirmButtonText, ...rest }) =>
      confirm({
        confirmButtonVariant: 'danger',
        confirmButtonText: confirmButtonText || t('delete'),
        icon: icon ?? <FaTrashAlt />,
        status: 'delete',
        ...rest,
      }),
    [confirm, t],
  );

  return {
    confirmDelete,
  };
};
